import { DialogComponent } from '@theme/dialog';

/**
 * The club join overlay: a pre-rendered, hidden copy of the club join page
 * content that lives in the product template (see sections/club-join.liquid
 * with "Present as overlay" enabled). The Tectalic wine club app block inside
 * initialises on page load, so opening and closing is purely a matter of
 * display — nothing is fetched or re-initialised.
 *
 * The trigger link elsewhere on the page targets this component by id:
 * `on:click="#be-club-overlay/open"`.
 */
class ClubOverlayComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener('click', this.#guardRerenderedTargets);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.dialog.removeEventListener('click', this.#guardRerenderedTargets);
  }

  /**
   * The wine club widget re-renders on some button clicks, detaching the
   * clicked element before the event bubbles up to DialogComponent's
   * outside-click check. A detached target fails dialog.contains() there and
   * the overlay closes even though the click landed inside it. The dialog is
   * modal, so a click whose target is now detached can only have originated
   * inside it — swallow the event before the check runs. Backdrop clicks
   * target the dialog element itself, so click-off-to-close is unaffected.
   *
   * @param {MouseEvent} event - A click bubbling through the dialog.
   */
  #guardRerenderedTargets = (event) => {
    if (event.target instanceof Element && !event.target.isConnected) {
      event.stopPropagation();
    }
  };

  /**
   * Opens the overlay in place of following the trigger link (which points
   * at the standalone club join page as the no-JS fallback).
   *
   * @param {Event} event - The click event on the trigger link.
   */
  open(event) {
    event.preventDefault();
    this.showDialog();
  }
}

if (!customElements.get('be-club-overlay-component')) {
  customElements.define('be-club-overlay-component', ClubOverlayComponent);
}
